module.exports = new __parcel__URL__("Financial.9ed526e9.jpg").toString();